import GlobalVariable from '@/global/global-variable'

// 查询人员绑定记录
// const searchUserRecord = GlobalVariable.BASE_PATH + "/rest/user/visit/record/search";
const searchUserRecord = GlobalVariable.BASE_PATH + "/rest/user/base/searchRecord";
// 导出人员绑定记录
// const exportUserRecord = GlobalVariable.BASE_PATH + "/rest/user/visit/record/exportExcel";
const exportUserRecord = GlobalVariable.BASE_PATH + "/rest/user/base/record/exportExcel";

// 查询车辆绑定记录
const searchCarRecord = GlobalVariable.BASE_PATH + "/rest/car/searchRecord";
// 导出车辆绑定记录
const exportCarRecord = GlobalVariable.BASE_PATH + "/rest/car/exportRecord";

// 查询绑定记录 GPS Tag
const searchGpsTagRecord = GlobalVariable.BASE_PATH + "/rest/gps/tag/searchRecord";
// 导出绑定记录 GPS Tag
const exportGpsTagRecord = GlobalVariable.BASE_PATH + "/rest/gps/tag/exportRecord";

export default {
	
    // 查询人员绑定记录
    searchUserRecord,
    // 导出人员绑定记录
    exportUserRecord,

    // 查询车辆绑定记录
    searchCarRecord,
    // 导出车辆绑定记录
    exportCarRecord,
    
    // 查询绑定记录 GPS Tag
    searchGpsTagRecord,
    // 导出绑定记录 GPS Tag
    exportGpsTagRecord,

}



// WEBPACK FOOTER //
// ./src/request/api-record.js